<script setup lang="ts">
import frameTop from '~/assets/images/newsletter-frame-top-small@2x.webp'
import frameBottom from '~/assets/images/newsletter-frame-bottom-small@2x.webp'

const props = defineProps<{
  data: SectionNewsletterSubscriptionRecord
  moduleIndex: number
}>()

const { level, isSemantic } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme,
  !!props.data.title
)
const isFormSubmitted = ref(false)
</script>

<template>
  <div
    class="container grid-default my-10 max-w-xs overflow-hidden py-16 lg:my-20 lg:max-w-none lg:py-20"
  >
    <div
      class="relative col-span-full px-4 text-center lg:col-span-5 lg:col-start-1 lg:text-left xl:col-span-4 xl:col-start-2 2xl:col-span-3 2xl:col-start-2"
    >
      <Image
        loading="lazy"
        :src="frameTop"
        class="absolute -top-15 left-0 origin-center lg:top-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2 lg:-rotate-90"
        :width="309"
        :height="136"
        alt=""
      />
      <Heading
        v-if="data.title"
        class="mb-4 text-2xl font-medium lg:text-5xl-m"
        :level="level"
        :size="undefined"
        :is-semantic="isSemantic"
      >
        {{ data.title }}
      </Heading>
      <div v-if="data.description" class="text-sm font-medium text-neutral-500 lg:text-lg">
        {{ data.description }}
      </div>
    </div>
    <div class="relative col-span-full lg:col-span-6 lg:col-start-6">
      <Image
        loading="lazy"
        :src="frameBottom"
        class="absolute -bottom-16 right-0 origin-center lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-1/2 lg:-rotate-90"
        :width="309"
        :height="136"
        alt=""
      />
      <div class="h-full px-4">
        <HubSpotNewsletterSubscription
          v-if="!isFormSubmitted"
          :disclaimer="data.disclaimer"
          @submit="isFormSubmitted = true"
        />
        <ThankYouMessage v-else :message="data.thankYouMessage" />
      </div>
    </div>
  </div>
</template>
